import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { CommonValues } from 'src/app/services/commonValues';
import { environment } from 'src/environments/environment';

interface MenuItem {
  label: string;
  route: string;
  active: boolean;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [BsDropdownModule, CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrls: ["./header.component.scss", "../../../assets/newassets/custom.css", "../../../styles/SCSS/vendor/bootstrap/dist/css/bootstrap.css"]
})


export class HeaderComponent implements OnInit {
  ENVIRONMENT = environment;

  constructor(private router: Router, private refresh: CommonValues,
    private elementRef: ElementRef,
  ) { }

  ngOnInit() {
    this.checkScroll();

    // const signup = document.getElementById('signupFree');
    // signup.addEventListener('click' , ()=>{
    //  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    //   this.router.navigate(["/auth/signUp"]));
    //  })
  }

  routePath() {
    this.refresh.setReloadthePage("");
    this.router.navigate(["/auth/signUp"]);
  }

  isMobileMenuOpen = false;
  isMobileView: boolean = false;


  //  toggleMobileMenu() {
  //    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  //  }
  isOpen: boolean = false;

  showDropdown(): void {
    this.isOpen = true;
  }

  hideDropdown(): void {
    this.isOpen = false;
  }

  menuItems: MenuItem[] = [
    { label: 'Recruiters', route: 'web/recruiters.html', active: false },
    { label: 'Bench Sales', route: 'web/bench-sales.html', active: false },
    { label: 'Job Seekers', route: 'web/job-seekers.html', active: false },
    { label: 'Benefits', route: 'web/benefits.html', active: false }
  ];
  //  toggleDropdown(): void {
  //   this.isOpen = !this.isOpen;
  // }
  selectedItem: MenuItem = this.menuItems[0]; // Default selection

  selectItem(item: MenuItem): void {
    this.menuItems.forEach(i => i.active = false);
    item.active = true;
    this.selectedItem = item;
    this.isOpen = false;
  }

  // Optional: close dropdown when clicking outside
  // @HostListener('document:click', ['$event'])
  // onDocumentClick(event: MouseEvent): void {
  //   const dropdown = this.elementRef.nativeElement.querySelector('.custom-dropdown');
  //   if (!dropdown.contains(event.target)) {
  //     this.isOpen = false;
  //   }
  // }

  isDropdownOpen: boolean = false;
  // isMobileMenuOpen: boolean = false;
  scrolled: boolean = false;

  // constructor(private router: Router) { }

  // ngOnInit(): void {
  //   // Check initial scroll position
  //   this.checkScroll();
  // }

  @HostListener('window:scroll', [])
  checkScroll() {
    this.scrolled = window.scrollY > 50;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  navigate(path: string) {
    this.router.navigate([path]);
    this.isMobileMenuOpen = false;
  }

}

